import { render, staticRenderFns } from "./ElectLegislator.vue?vue&type=template&id=fe54fe6e&"
import script from "./ElectLegislator.vue?vue&type=script&lang=js&"
export * from "./ElectLegislator.vue?vue&type=script&lang=js&"
import style0 from "./ElectLegislator.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports